import Vue from 'vue';
import LPolylineOffset from 'vue2-leaflet-polylineoffset';
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster';
import VueI18n from 'vue-i18n';
import { createI18n } from 'vue-i18n-composable';
import JsonCsv from 'vue-json-csv';
import { defaultLocale, messages } from '@/constants/i18n';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';

Vue.use(VueI18n);

const i18n = createI18n({
  messages,
  locale: defaultLocale,
  fallbackLocale: defaultLocale
});

Vue.config.productionTip = false;

function mountVue() {
  new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
  }).$mount('#app');

  Vue.component('LPolylineOffset', LPolylineOffset);
  Vue.component('VMarkerCluster', Vue2LeafletMarkerCluster);
  Vue.component('DownloadCsv', JsonCsv);
}

mountVue();
